import { render, staticRenderFns } from "./FiskaResponse.vue?vue&type=template&id=afbb156c&scoped=true"
import script from "./FiskaResponse.vue?vue&type=script&lang=js"
export * from "./FiskaResponse.vue?vue&type=script&lang=js"
import style0 from "./FiskaResponse.vue?vue&type=style&index=0&id=afbb156c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbb156c",
  null
  
)

export default component.exports